import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EnvironmentService } from '@galaxy/core';

@Injectable({ providedIn: 'root' })
export class ForgotPasswordGuard {
  constructor(private environmentService: EnvironmentService) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const env = this.environmentService.getEnvironmentString();
    const href = `https://login-${env}.apigateway.co/account-selector/request-password-reset?serviceProviderId=AA`;

    window.location.href = href;
    return true;
  }
}
